/*
    不良理由を選択するリスト
*/
import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Defect } from "../../redux/defectTypesSlice";
import cloneDeep from "lodash/cloneDeep";

export type DefectTypeSelectProp = {
  // ラベル
  label: string;
  // 選択中の不良品理由コード
  selectDefectsType: string;
  // 不良品理由コードが選択された場合のイベント処理
  handleDefectsTypeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
};

export const DefectTypeSelect: React.FC<DefectTypeSelectProp> = ({
  label,
  selectDefectsType,
  handleDefectsTypeChange,
}) => {
  // このコンポーネントでユニークなID
  const id =
    "defect-type-select-" +
    new Date().getTime().toString(16) +
    Math.floor(1000 * Math.random()).toString(16);
  // 言語設定
  const language = useSelector((state: RootState) => state.user.language);
  // 不良理由区分の一覧
  const defectTypes = useSelector(
    (state: RootState) => state.defectTypes.defectsTypes
  );
  // グループID抽出
  let uniqueDefectGroups = Array.from(
    new Map(
      defectTypes.map((defectType) => [defectType.defect_group_id, defectType])
    ).values()
  );
  // グループIDでソート
  uniqueDefectGroups.sort(
    (a: any, b: any) => a.defect_group_id - b.defect_group_id
  );
  let defectsOptions = [<option value="">-</option>];
  uniqueDefectGroups.forEach((defectGroup) => {
    const filterdDefectsTypes = defectTypes.filter(
      (d) => d.defect_group_id === defectGroup.defect_group_id
    );
    // グループ内でソート
    let sortedDefectTypes = cloneDeep(filterdDefectsTypes).sort(
      (a: Defect, b: Defect) => a.defect_type_id - b.defect_type_id
    );
    sortedDefectTypes.sort(
      (a: Defect, b: Defect) => a.defect_group_id - b.defect_group_id
    );

    const options = sortedDefectTypes.map((d, index) => {
      let name = d.defect_type[language];
      if (name === undefined) {
        name = d.defect_type["ja"];
      }
      return (
        <option
          key={defectGroup.defect_group_id + ":" + d.defect_type_id}
          value={d.defect_type_id}
        >
          &nbsp;&nbsp;{`${d.defect_type_id}: ${name}`}
        </option>
      );
    });

    let groupName = defectGroup.defect_group[language];
    if (groupName === undefined) {
      groupName = defectGroup.defect_group["ja"];
    }
    const groupOption = (
      <option
        key={defectGroup.defect_group_id}
        value={""}
        disabled={true}
        className="groupOption"
      >
        {` ${defectGroup.defect_group_id}: ${groupName}`}
      </option>
    );
    defectsOptions = [...defectsOptions, groupOption, ...options];
  });

  return (
    <>
      {label !== "" ? <label htmlFor={id}>{label}</label> : null}
      <select
        id={id}
        defaultValue=""
        className="input-180"
        value={selectDefectsType}
        onChange={handleDefectsTypeChange}
      >
        {defectsOptions}
      </select>
    </>
  );
};
